import CapsLockLabel from './CapsLockLabel';

export default CapsLockLabel;
